import React, { useState, useEffect } from 'react';
import { funFacts } from '../utils/funFacts';

const Loading = ({
  size = 'md',
  showFunFact = true,
  className = '',
  message = 'Chargement...',
  factChangeInterval = 3000
}) => {
  const [currentFact, setCurrentFact] = useState('');

  // Sélectionner un fait aléatoire au montage et à intervalles réguliers
  useEffect(() => {
    if (!showFunFact) return;

    const getRandomFact = () => {
      const randomIndex = Math.floor(Math.random() * funFacts.length);
      return funFacts[randomIndex].fact;
    };

    // Définir le premier fait
    setCurrentFact(getRandomFact());

    // Changer de fait à intervalles réguliers
    const interval = setInterval(() => {
      setCurrentFact(getRandomFact());
    }, factChangeInterval);

    return () => clearInterval(interval);
  }, [showFunFact, factChangeInterval]);

  // Tailles du spinner
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
    xl: 'h-20 w-20'
  };

  const spinnerSize = sizeClasses[size] || sizeClasses.md;

  return (
    <div className={`flex flex-col items-center justify-center space-y-4 ${className}`}>
      {/* Spinner */}
      <div className="flex flex-col items-center space-y-3">
        <div className={`animate-spin rounded-full border-t-2 border-b-2 border-blue-500 ${spinnerSize}`}></div>
        {message && (
          <p className="text-gray-600 dark:text-gray-400 text-sm font-medium">
            {message}
          </p>
        )}
      </div>

      {/* Fun Fact */}
      {showFunFact && currentFact && (
        <div className="max-w-md mx-auto">
          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
            <div className="flex items-start space-x-2">
              <div className="flex-shrink-0">
                <span className="text-blue-500 text-lg">💡</span>
              </div>
              <div>
                <p className="text-xs font-medium text-blue-800 dark:text-blue-300 mb-1">
                  Le saviez-vous ?
                </p>
                <p className="text-sm text-blue-700 dark:text-blue-200 leading-relaxed">
                  {currentFact}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Loading;